import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-c-one-one',
  templateUrl: './c-one-one.component.html',
  styleUrls: ['./c-one-one.component.scss']
})
export class COneOneComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showHeading = false;
  showSideMenu = true;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5 ){
      this.showSideMenu=true;
      this.fullWidth=false;
      this.showHeading = true
    }
    else if(url.length === 6){
      this.showSideMenu=false;
      this.fullWidth=false;
      this.showHeading = false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
